<template>
  <div class="layout h-full bg-bg-1 flex flex-col">
    <template v-if="loading">
      <SkeletonPage></SkeletonPage>
      <!-- 预估时间 -->
      <NewLoading :loading-text="loadingTips"></NewLoading>
    </template>
    <div
      v-else
      class="flex-1 h-full"
    >
      <PageHeader />
      <!-- #detail-main-container 在 ChartCard.vue 中使用 -->
      <div
        id="detail-main-container"
        class="relative flex-1 flex detail-page-content"
      >
        <MainContent />
        <div
          class="relative side-wrap h-full transition-all"
          :class="{ open: activityDetailStoreRef.sidebarOpenStatus }"
        >
          <RightSide />
          <DrawerToggle
            foldDirection="right"
            :openStatus="activityDetailStoreRef.sidebarOpenStatus"
            @toggle="activityDetailStoreRef.toggleSidebarStatus()"
          />
        </div>
      </div>
    </div>
    <!-- tipsModal 弹窗提示 -->
    <TipsModal />
  </div>
</template>

<script setup>
import { watch, ref, computed, nextTick, getCurrentInstance, onBeforeMount } from 'vue';
import { activityDetailStore } from '@client/store/activityDetailStore';
import TipsModal from '../layout/components/tipsModal/tipsModal.vue';
import PageHeader from './components/header/index.vue';
import RightSide from './sidebar/RightSide.vue';
import { initStore } from '@client/store/initStore';
import { userStore } from '@client/store/userStore';
import MainContent from './main/MainContent.vue';
import NewLoading from './components/NewLoading/index.vue';
import DrawerToggle from '@client/components/DrawerToggle.vue';
import { Message } from '@arco-design/web-vue';
import SkeletonPage from './components/skeletonPage/index.vue';
import { useRoute } from 'vue-router';
import { useModels } from './main/chart/useModels';

const vm = getCurrentInstance();
Message._context = vm?.appContext;

const route = useRoute();

const initStoreRef = initStore();
const userStoreRef = userStore();
const activityDetailStoreRef = activityDetailStore();

const { userId, labelId, sportType, teamId } = route.query;
activityDetailStoreRef.$patch({ userId, labelId, sportType: Number(sportType), teamId });

const loading = computed(() => activityDetailStoreRef.loading);

const { models } = useModels();

onBeforeMount(async () => {
  initStoreRef.getPublicProfile();
  userStoreRef.initUserInfo();
  const isTeam = !!teamId;
  const option = isTeam
    ? {
        labelId,
        sportType,
        teamId,
        userId
      }
    : {
        labelId,
        sportType
      };
  activityDetailStoreRef.getActivityDetail(isTeam, option).then(async () => {
    updateModal();

    const commentPermission = await activityDetailStoreRef.getTeamUserPermission(isTeam, { teamId, userId });
    if (!isTeam || commentPermission) activityDetailStoreRef.getCommentList();
  });
});
function updateModal() {
  let chartModel;
  // 当切换到概况时，图表恢复为时间图表
  if (activityDetailStoreRef.activityDetail?.sportDataDetailList?.length > 0) {
    chartModel = 'time';
  } else {
    // 为子运动
    if (!models.value.map((item) => item.key).includes(activityDetailStoreRef.chartModel)) {
      chartModel = 'time';
    }
  }
  if (chartModel) activityDetailStoreRef.changeChartModel(chartModel);
}

// watch(loading, (val) => {
//   if (!val) {
//     console.log('data loaded ok')
//     updateModal();
//     activityDetailStoreRef.reInitData();
//   }
// });

const loadingErrTip = computed(() => activityDetailStoreRef.loadingErrTip);
const loadingTips = computed(() => activityDetailStoreRef.loadingTips);
watch(loadingErrTip, () => {
  nextTick(() => {
    if (loadingErrTip.value) Message.error(loadingErrTip.value);
  });
});
</script>

<style lang="scss" scoped>
@import '@client/styles/_mixins.scss';
.detail-page-content {
  height: calc(100% - 72px - 1px);
  color: #fff;
}
.side-wrap {
  width: 0;

  &.open {
    width: px2rem144(340);
  }
}
</style>
